export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./error.vue?vue&type=template&id=419ae480&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/error.vue?vue&type=template&id=419ae480&
// module id = 920
// module chunks = 0